import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { renderChildren, text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<span> </span>`);
var root_1 = $.from_html(`<div class="slex-card-title"><!><!></div>`);
var root_2 = $.from_html(`<div class="slex-card"><!> <div class="slex-card-body"></div></div>`);

export default function Card($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	var div = root_2();
	var node = $.child(div);

	{
		var consequent_2 = ($$anchor) => {
			var div_1 = root_1();
			var node_1 = $.child(div_1);

			{
				var consequent = ($$anchor) => {
					InlineIcon($$anchor, {
						get name() {
							return $.get(p).icon;
						},
						className: 'slex-card-icon'
					});
				};

				$.if(node_1, ($$render) => {
					if ($.get(p).icon) $$render(consequent);
				});
			}

			var node_2 = $.sibling(node_1);

			{
				var consequent_1 = ($$anchor) => {
					var span = root();
					var text_1 = $.child(span, true);

					$.reset(span);
					$.template_effect(($0) => $.set_text(text_1, $0), [() => text($.get(p).title)]);
					$.append($$anchor, span);
				};

				$.if(node_2, ($$render) => {
					if ($.get(p).title) $$render(consequent_1);
				});
			}

			$.reset(div_1);
			$.append($$anchor, div_1);
		};

		$.if(node, ($$render) => {
			if ($.get(p).title || $.get(p).icon) $$render(consequent_2);
		});
	}

	var div_2 = $.sibling(node, 2);

	$.action(div_2, ($$node, $$action_arg) => renderChildren?.($$node, $$action_arg), () => $$props.ctx);
	$.reset(div);

	$.template_effect(
		($0, $1) => {
			$.set_attribute(div, 'data-tone', $0);
			$.set_attribute(div, 'data-variant', $1);
		},
		[
			() => $.get(p).tone ? text($.get(p).tone) : undefined,
			() => $.get(p).variant || $.get(p).presentation
				? text($.get(p).variant ?? $.get(p).presentation)
				: undefined
		]
	);

	$.append($$anchor, div);
	$.pop();
}